import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ErrorMessage} from '@catloader/loader-service/types';
import {getFactory} from '@catloader/loader-service/utils/webapi-error-helper';
import {NotificationsService} from 'app/modules/core/services/index';
import 'rxjs/add/observable/throw';
import {Observable} from 'rxjs/Observable';
import {catchError, finalize, map} from 'rxjs/operators';
import {ReplaySubject} from 'rxjs/ReplaySubject';

/**
 * A middleware for the HttpClient service to handle requests.
 *
 * It provides the information about if pending requests are available or not.
 *
 * This service is used as a middleware (interceptor) for the @angular HttpClient and also as a direct accessible service for
 * application services and components
 *
 * It is a replacement for LoaderService and HttpClient after all legacy usages of the Http service
 * is removed from the application
 *
 */
@Injectable()
export class PendingInterceptorService implements HttpInterceptor {
  private _pendingRequests = 0;
  private _pendingRequestsStatus: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private _filteredUrlPatterns: RegExp[] = [];

  get pendingRequestsStatus(): Observable<boolean> {
    return this._pendingRequestsStatus.asObservable();
  }

  get pendingRequests(): number {
    return this._pendingRequests;
  }

  get filteredUrlPatterns(): RegExp[] {
    return this._filteredUrlPatterns;
  }

  private errorMessageFactory;

  constructor(private notificationService: NotificationsService){
    this.errorMessageFactory = getFactory();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldBypass = this.shouldBypass(req.url);

    if (!shouldBypass) {
      this._pendingRequests++;

      if (1 === this._pendingRequests) {
        this._pendingRequestsStatus.next(true);
      }
    }

    return next.handle(req).pipe(
      map((event) => {
        return event;
      }),
      catchError((response: HttpErrorResponse) => {
        this.errorMessageFactory
          .forHttpResponse(response)
          .forEach((message: ErrorMessage) => {
            this.notificationService.error(message.title, message.message);
          });
        return Observable.throw(response);
      }),
      finalize(() => {
        if (!shouldBypass) {
          this._pendingRequests--;

          if (0 === this._pendingRequests) {
            this._pendingRequestsStatus.next(false);
          }
        }
      }),
    );
  }

  private shouldBypass(url: string): boolean {
    return this._filteredUrlPatterns.some((e) => {
      return e.test(url);
    });
  }

}

export function PendingInterceptorServiceFactory(notificationService: NotificationsService) {
  return new PendingInterceptorService(notificationService);
}

export let PendingInterceptorServiceFactoryProvider = {
  provide: PendingInterceptorService,
  useFactory: PendingInterceptorServiceFactory,
  deps: [NotificationsService],
};



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/loader-service/services/pending-interceptor.service.ts